/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
/* eslint-enable */

export default createPerimeter({
  purpose: 'base',

  can: {
    view() {
      return true
    },

    viewDeveloperNotes() {
      // return this.isOneClose;
      return false
    },
    // update(article) {
    //   return this.child.isAdmin ||
    //     (this.child.isModerator && article.userId === this.child.id);
    // },
    //
    // destroy(article) {
    //   return this.isAllowed('update', article);
    // }
  },

  isSuper() {
    return this.child.isSuper;
  },

  isDeveloper() {
    return this.child.isDeveloper;
  },


  // isModerator() {
  //   return this.child.isModerator;
  // }
});
